import { Input } from "reactstrap"
import styles from './SearchBar.module.scss'

const SearchBar = ({ placeholder }) => {
  return (
    <div className={styles['search-bar-container']}>
      <Input type="text" placeholder={placeholder ? placeholder : "Filter by name, phone no. or email"} className={styles['search-input']} />
      <button className={styles['search-button']}>Search</button>
    </div>
  )
}

export default SearchBar
